// extracted by mini-css-extract-plugin
module.exports = {"layout":"AboutCard_layout__I9KRM"};